import { ModelFactory } from "../../../ModelFactory";

export class PHPConfig {
  constructor(
    public readonly ini: string,
    public readonly defaultPoolConfig: string,
    public readonly pools: string,
  ) {
  }
}

class PHPConfigFactory extends ModelFactory<PHPConfig> {
  protected fromJson(json: any): PHPConfig {
    return new PHPConfig(
      json['ini'],
      json['default_pool_config'],
      json['pools'],
    );
  }
}
export const phpConfigFactory = new PHPConfigFactory();
